import { message } from "antd";

export const validateBusinessHourData = (businessHourData) => {
  if (businessHourData?.isCalendarHours) {
    return true;
  }
  const invalidDay = Object.keys(businessHourData?.businessDays || {}).find((day) => {
    const { hourStartTime, hourEndTime, minuteStartTime, minuteEndTime, isOpen } = businessHourData?.businessDays[day];
    if (!isOpen) {
      return false;
    }
    if (isOpen && (!hourStartTime || !hourEndTime || !minuteStartTime || !minuteEndTime || hourStartTime === "00" || hourEndTime === "00")) {
      return true;
    }
    const startMinutes = parseInt(hourStartTime, 10) * 60 + parseInt(minuteStartTime, 10);
    const endMinutes = parseInt(hourEndTime, 10) * 60 + parseInt(minuteEndTime, 10);
    if (startMinutes >= endMinutes) {
      return true;
    }
    return false;
  });

  if (invalidDay) {
    message.warning("Please provide valid start and end times for all open business days.");
    return false;
  }

  if (!businessHourData?.timeZone) {
    message.warning("Please select a TimeZone.");
    return false;
  }

  if (!businessHourData?.businessDays || Object.keys(businessHourData?.businessDays).length === 0) {
    message.warning("Please provide Business Days Timing.");
    return false;
  }
  return true;
};

export const DEFAULT_BUSINESS_DAYS = [
  { hourStartTime: "09", hourEndTime: "17", isOpen: 0, minuteStartTime: "00", minuteEndTime: "00", businessDay: "0" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 1, minuteStartTime: "00", minuteEndTime: "00", businessDay: "1" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 1, minuteStartTime: "00", minuteEndTime: "00", businessDay: "2" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 1, minuteStartTime: "00", minuteEndTime: "00", businessDay: "3" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 1, minuteStartTime: "00", minuteEndTime: "00", businessDay: "4" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 1, minuteStartTime: "00", minuteEndTime: "00", businessDay: "5" },
  { hourStartTime: "09", hourEndTime: "17", isOpen: 0, minuteStartTime: "00", minuteEndTime: "00", businessDay: "6" },
];

export const BusinessHourType = {
  CALENDAR: 1,
  CUSTOM: 2,
};

export const BusinessHourLabel = {
  CALENDAR: "24/7",
  CUSTOM: "Custom",
};

export const BusinessHourSource = {
  ORG_SPECIFIC: "system",
  CALL_FLOW_SPECIFIC: "custom",
};